import { render, staticRenderFns } from "./NewPass.vue?vue&type=template&id=03d9abf2&scoped=true&"
import script from "./NewPass.vue?vue&type=script&lang=js&"
export * from "./NewPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d9abf2",
  null
  
)

export default component.exports